import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiLoginReminderService } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder.service';
import { FiLoginReminderHelperService } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder-helper.service';
import { FiLoginReminderEditComponent } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder-edit/fi-login-reminder-edit.component';
import { UIRouterModule } from '@uirouter/angular';
import { LoginReminderStates } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder-states';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FiTimePickerInputModule } from '@fi-shared/fi-time-picker-input/fi-time-picker-input.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { FiContenteditableModule } from '@fi-shared/fi-contenteditable/fi-contenteditable.module';
import { FiLoginNameInputModule } from '@fi-app/authenticate/login/login-name-input/login-name-input.module';
import { MatButtonModule } from '@angular/material/button';
import { FiLoginReminderNavigationTabsComponent } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder-navigation-tabs/fi-login-reminder-navigation-tabs.component';
import { FiStateSrefModule } from '@fi-shared/fi-state-proxy/state-sref/state-sref.module';
import { FiTabsModule } from '@fi-app/utilities/tabs/tabs.module';
import { FiButtonBackNewModule } from '@fi-shared/fi-button-back-new/fi-button-back-new.module';
import { FiLoginReminderOverviewComponent } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder-overview/fi-login-reminder-overview.component';
import { FiLoginReminderLogComponent } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder-log/fi-login-reminder-log.component';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatCell } from '@angular/material/table';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild(LoginReminderStates),
        FiAppTextSharedModule,
        FiToggleSwitchModule,
        MatButtonModule,
        MatSelectModule,
        MatCheckboxModule,
        MatRadioModule,
        FormsModule,
        FiTimePickerInputModule,
        FiContenteditableModule,
        FiLoginNameInputModule,
        FiStateSrefModule,
        FiTabsModule,
        FiButtonBackNewModule,
        FiWrapperTableModule,
        MatCell,
        FiWhenScrolledModule,
    ],
    declarations: [
        FiLoginReminderEditComponent,
        FiLoginReminderNavigationTabsComponent,
        FiLoginReminderOverviewComponent,
        FiLoginReminderLogComponent,
    ],
    providers: [FiLoginReminderService, FiLoginReminderHelperService],
})
export class FiLoginReminderModule {}
